import React from "react";
import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import SEO from "@/components/site/SEO";
import { useLanguage } from "@/i18n/LanguageContext";
import { useSettings } from "@/context/SettingsContext";
import { WA, trackEvent } from "@/lib/api";

const OrderSample = () => {
  const { t, lang, dict } = useLanguage();
  const { settings } = useSettings();
  const copy = dict.orderSample;
  const waMsg = lang === "en"
    ? "Hello, I want to order a powder drink sample from Mandala Cahaya Sentosa."
    : "Halo, saya ingin order sample minuman serbuk di PT Mandala Cahaya Sentosa.";
  const wa = WA(settings?.whatsapp_number, waMsg);

  return (
    <div>
      <SEO title={copy.seoTitle} description={copy.seoDesc} />

      <section className="pt-12 pb-8 bg-[#fff5f5]">
        <div className="container-wide max-w-4xl">
          <div className="text-xs uppercase tracking-[0.22em] text-maroon-700 font-bold">{copy.overline}</div>
          <h1 className="mt-3 text-4xl md:text-5xl font-display font-black text-zinc-900 tracking-tighter">{copy.title}</h1>
          <p className="mt-4 text-lg text-zinc-600 leading-relaxed">{copy.lead}</p>
        </div>
      </section>

      <section className="pb-16 md:pb-24 bg-[#fff5f5]">
        <div className="container-wide grid lg:grid-cols-2 gap-10 items-start">
          <div className="rounded-3xl overflow-hidden bg-[#e82020] shadow-lg shadow-maroon-800/20">
            <img src="/sampel-produk.png" alt={copy.imgAlt} className="w-full h-full object-cover" />
          </div>

          <div className="bg-white rounded-3xl border border-zinc-100 p-7 md:p-9">
            <h2 className="text-2xl font-display font-bold text-zinc-900">{copy.termsTitle}</h2>
            <ul className="mt-6 space-y-4">
              {(copy.terms || []).map((item, i) => (
                <li key={i} className="flex items-start gap-3">
                  <span className="w-7 h-7 rounded-full bg-maroon-100 text-maroon-800 flex items-center justify-center shrink-0 mt-0.5">
                    <Check size={14} />
                  </span>
                  <span className="text-zinc-700 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>

            <div className="mt-8 p-5 rounded-2xl bg-maroon-50 border border-maroon-100">
              <div className="text-sm font-bold uppercase tracking-wider text-maroon-800">{copy.freeBadge}</div>
              <p className="mt-2 text-zinc-700 leading-relaxed">{copy.freeNote}</p>
            </div>

            <div className="mt-8 flex flex-wrap gap-3">
              <a
                href={wa}
                target="_blank"
                rel="noopener noreferrer"
                onClick={() => trackEvent("click", "/order-sample", "whatsapp")}
                className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-maroon-800 text-white font-semibold hover:bg-maroon-900"
              >
                {copy.cta} <ArrowRight size={16} />
              </a>
              <Link to="/kontak" className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-maroon-800 text-maroon-800 font-semibold">
                {t("nav.contact")}
              </Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrderSample;
